/**
 * Represents the application environment
 */
export type EnvironmentType = "development" | "staging" | "production"

/**
 * Events emitted by the ClientData class
 */
export enum ClientDataEvents {
  ITEM_UPDATED = "itemUpdated",
  ITEM_PLAINTEXT_UPDATED = "itemPlaintextUpdated",
}
